import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./Home/Home";
import { Layout } from "./Home/Layout";
import Request from "./Request/Request";
import Report from "./Report/Report";

export default function DataExtractionToolRoutes() {
  return (
    <>
      <Layout></Layout>

      <Routes>
        {/* <Route path="/" element={<Home />} /> */}
        <Route path="/Request" element={<Request />} />
        <Route path="/Report" element={<Report />} />
      </Routes>
    </>
  );
}
